// -- AUTOGENERATED --

// eslint-disable-next-line no-unused-vars
import APIUtils from '@/util/apiutil'

import Axios from 'axios'
import NETVSConfig from '@/../netvs.config'

/* eslint-disable camelcase */
/* eslint-disable quote-props */
/* eslint-disable object-curly-spacing */
/* eslint-disable array-bracket-spacing */
/* eslint-disable object-shorthand */
export default {

  createParamsList () {
    return {'old': [ ], 'new': [ 'group_name', 'mgr_login_name']}
  },
  create (config, {group_name_new, mgr_login_name_new}) {
    const params = { 'new': { 'group_name': group_name_new, 'mgr_login_name': mgr_login_name_new}, 'old': { }}
    // TODO: Return ta-object instead
    return Axios.post(`${NETVSConfig.NETDB_API_BASE_URL}/${NETVSConfig.NETDB_API_VERSION}/cntl/mgr2group/create`, params, (config || {}).netdb_axios_config)
  // eslint-disable-next-line comma-dangle
  },
  deleteParamsList () {
    return {'old': [ 'group_name', 'mgr_login_name'], 'new': [ ]}
  },
  delete (config, {group_name_old, mgr_login_name_old}) {
    const params = { 'new': { }, 'old': { 'group_name': group_name_old, 'mgr_login_name': mgr_login_name_old}}
    // TODO: Return ta-object instead
    return Axios.post(`${NETVSConfig.NETDB_API_BASE_URL}/${NETVSConfig.NETDB_API_VERSION}/cntl/mgr2group/delete`, params, (config || {}).netdb_axios_config)
  // eslint-disable-next-line comma-dangle
  },
  list (config, { is_own, gpk_list, fetch_limit, fetch_offset, group_name_list, filter_params_dict, mgr_login_name_list, sorting_params_list }) {
    const params = APIUtils.denullify_dict({ 'is_own': is_own, 'gpk_list': (gpk_list === null) ? null : JSON.stringify(gpk_list), 'fetch_limit': fetch_limit, 'fetch_offset': fetch_offset, 'group_name_list': (group_name_list === null) ? null : JSON.stringify(group_name_list), 'filter_params_dict': filter_params_dict, 'mgr_login_name_list': (mgr_login_name_list === null) ? null : JSON.stringify(mgr_login_name_list), 'sorting_params_list': (sorting_params_list === null) ? null : JSON.stringify(sorting_params_list)})
    const cnf = {}
    Object.assign(cnf, (config || {}).netdb_axios_config)
    cnf.params = params
    return Axios.get(`${NETVSConfig.NETDB_API_BASE_URL}/${NETVSConfig.NETDB_API_VERSION}/cntl/mgr2group/list`, cnf)
  // eslint-disable-next-line comma-dangle
  },
}
